import { Component } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';

const URL = '/api/receipt/upload';

@Component({
    selector: 'upload',
    template: require('./upload.component.html')
})
export class UploadComponent {
    public uploader:FileUploader = new FileUploader({url: URL});
    public hasBaseDropZoneOver:boolean = false;
    public hasAnotherDropZoneOver:boolean = false;

    public fileOverBase(e:any):void {
        this.hasBaseDropZoneOver = e;
    }

    public fileOverAnother(e:any):void {
        this.hasAnotherDropZoneOver = e;
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/admin/upload/upload.component.ts